import { useTerritoriosStore } from '@/store/territorios'
import { useTerritorioStore } from '@/store/territorio'
import { useRouterStore } from '@/store/router'
import { useRutasStore } from '@/page/rutas/useRutasStore'
import { useApi } from '@/composables/useApi'

export const useSaveTerritorio = () => {
  const territorios = useTerritoriosStore()
  const terr = useTerritorioStore()
  const route = useRouterStore()
  const rutas = useRutasStore()
  const api = useApi()

  const execute = async () => {
    const data = await terr.getData()

    if (data.tipo === 'routes') {
      const rutasMza = [[{ lat: data.center[0], lng: data.center[1] }, 0]]
      for (let i in data.routes) {
        const r = rutas.list.find((r) => r.id === data.routes[i])
        if (r?.route?.length > 0) {
          rutasMza.push([{ lat: r.route[0][0], lng: r.route[0][1] }, parseInt(i) + 1])
        }
      }
      data.mzNumbers = [...rutasMza]
    }

    await territorios.update(data)
    const result = await api.put(`/api/territories/${data.uuid}`, data)
    if (result?.error) {
      console.error('Error al guardar territorio:', result.error)
      return { error: result.error }
    }

    terr.clear()
    route.$patch({ page: 'listaTerritorio' })
  }

  return { execute }
}
